import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Select,
  TextField,
  Button,
  Box,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableView from "../../../CustomComponent/TableView";
import QuestionListHead from "./QuestionListHead";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as ExportIcon } from "../../../images/commonicon/exporticon.svg";
import PublishIcon from "@material-ui/icons/Publish";
function AddMarks({ changeTab, batchId }) {
  const classes = useStyles();
  const params = useParams();
  const { state } = useLocation();

  const total_score = state?.total_score || 0;
  // console.log('params',params?.rorowId)
  const [answerKeyData, setAnswerKeyData] = useState([]);
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [examName, setExamName] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const [lengthOfTextfield, setLengthOfTextfield] = useState(0);
  const id = popoveropen ? "simple-popover" : undefined;
  const [examid, setExamId] = useState();
  const [questionList, setQuestionList] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [examData, setExamData] = useState("");
  const [isNewAnswerKey, setIsNewAnswerKey] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  // const [searchQuery, setSearchQuery] = useState("");




  const handlePageChange = (newPage) => {
    setPage(newPage);
    setPageNumber(newPage);
  };

  const style = [
    {
      height: "maxh67",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: isNewAnswerKey ? questions.length : rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: isNewAnswerKey ? "client" : "server",
    },
  ];

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      setExamId(response?.data?.exam?.id)
      setExamName(response?.data?.exam?.exam_name || "");
      setExamData(response.data.exam)
      setSubjects(response.data.exam.subjects || []);
      setExamId(response?.data?.exam?.id);
      setExamName(response?.data?.exam?.exam_name || "");
      setExamData(response.data.exam);

      // Calculate total questions from subjects
      const totalQuestions = response.data.exam.subjects.reduce(
        (sum, subject) => sum + subject.question_count,
        0,
      );
      setLengthOfTextfield(totalQuestions);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [rowId]);

  // console.log("examData-------", examData);

  const fetchAnswerKey = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/exam/${rowId}?page=${pageNumber + 1}&limit=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      const data = response.data?.answerKeys || [];

      if (data.length > 0) {
        const formatted = data.map((item, i) => ({
          id: item.id || i + 1,
          question_number: item.question_number,
          answer: item.answer || "",
          question_type: item.question_type || "",
          scoring_scheme_id: item?.scoring_scheme?.id || "",
          subject_id: item.subject_id || "",
        }));

        setQuestions(formatted); // ✅ This sets data to input fields
        setLengthOfTextfield(data.length);
        setRowCount(response.data.count);
        setIsNewAnswerKey(false);
      } else {
        if (!isNewAnswerKey) {
          setQuestions([]);
        }
        setIsNewAnswerKey(true);
      }
    } catch (err) {
      console.error(
        "Failed to fetch answer key:",
        err.response?.data || err.message,
      );
      setIsNewAnswerKey(true); // On error, assume new
    }
  };

  const fetchSubjectData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setSubjects(response.data.subjects);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // useEffect(() => {
  //   fetchSubjectData();
  // }, []);

  const fetchSchemeData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/scoring/schemes`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setSchemes(response.data.schemes);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchSchemeData();
  }, []);

  useEffect(() => {
    // if (lengthOfTextfield > 0 && questions.length === 0) {
    if (examData?.subjects && lengthOfTextfield > 0 && questions.length === 0) {
      let questionCounter = 1;
      // const newRows = Array.from({ length: lengthOfTextfield }, (_, i) => ({
      const newRows = examData.subjects.flatMap((subject) =>
        Array.from({ length: subject.question_count }, (_, index) => ({
          id: questionCounter,
          question_number: questionCounter++,
          answer: "",
          question_type: "",
          scoring_scheme_id: "",
          subject_id: subject.subject_id,
        })),
      );
      setQuestions(newRows);
    }
  }, [examData, lengthOfTextfield]);

  // const handleFieldChange = (id, field, value) => {
  //   setQuestions((prevQuestions) =>
  //     prevQuestions.map((question) =>
  //       question.id === id ? { ...question, [field]: value } : question
  //     )
  //   );
  // };
  const handleFieldChange = (id, field, value) => {
    console.log("Changing id:", id, "Field:", field, "Value:", value);
    setQuestions((prevQuestions) =>
      prevQuestions.map((question) =>
        question.id === id ? { ...question, [field]: value } : question,
      ),
    );
  };
  const handleSave = async () => {
    const answer_keys = questions.map((q, i) => {
      console.log("q id----", q.id);
      return {
        // id: q.id || undefined,
        id: isNewAnswerKey ? undefined : q.id,
        question_number: Number(q.question_number || i + 1),
        answer: q.answer || "",
        question_type: q.question_type || "",
        scoring_scheme_id: q.scoring_scheme_id || "",
        subject_id: q.subject_id || "",
      };
    });

    // for (let q of answer_keys) {
    //   if (!q.answer || isNaN(q.marks)) {
    //     toast.error(
    //       `Invalid data for Question ${q.question_number}. Please fill all fields.`
    //     );
    //     return;
    //   }
    // }

    for (let q of answer_keys) {
      if (
        !q.answer ||
        !q.question_type ||
        !q.scoring_scheme_id ||
        !q.subject_id
      ) {
        toast.error(
          `Invalid data for Question ${q.question_number}. Please fill all fields.`,
        );
        return;
      }
    }

    const payload = {
      exam_id: examid,
      // Subject_id: "", // If needed
      answer_keys,
    };

    const hasExistingIds = questions.some((q) => q.id);
    console.log("answerKeyData", isNewAnswerKey);
    // const url = hasExistingIds
    //   ? `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/awnserkey/update`
    //   : `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/add`;
    //   // : `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/awnserkey/add`;

    const url = isNewAnswerKey
      ? `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/add`
      : `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/update`;

    const method = isNewAnswerKey ? "post" : "put";

    try {
      const response = await axios({
        method,
        url,
        data: payload,
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      });
      toast.success(
        isNewAnswerKey
          ? "Answer key Added successfully!"
          : "Answer key updated successfully!",
      );
      fetchAnswerKey();
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error("Failed to save answer key. Check console for details.");
    }
  };

  const [questionCount, setQuestionCount] = useState(0);
  const [tableRowData, setTableRowData] = useState([]);

  // useEffect(() => {
  //   setRowCount(questions.length);
  // }, [questions]);

  useEffect(() => {
    fetchAnswerKey();
  }, [pageNumber, pageSize,rowId]);

  const columns = [
    {
      field: "question_number",
      headerName: "Question No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "answer",
      headerName: "Answer",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => (
        <TextField
          value={cellValues.row.answer || ""}
          onChange={(e) =>
            handleFieldChange(cellValues.row.id, "answer", e.target.value)
          }
          placeholder="Enter Answer"
          variant="outlined"
          required
        />
      ),
    },
    {
      field: "question_type",
      headerName: "Question Type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Select
          style={{ width: "100%" }}
          value={cellValues.row.question_type || ""}
          onChange={(e) =>
            handleFieldChange(cellValues.row.id, "question_type", e.target.value)
          }
          displayEmpty
          variant="outlined"
        >
          <MenuItem disabled value="">
            Select type
          </MenuItem>

          <MenuItem value="singleChoice">
            Single Choice
          </MenuItem>
          <MenuItem value="multipleChoice">
            Multiple Choice
          </MenuItem>
          <MenuItem value="numeric">
            Numeric
          </MenuItem>


        </Select>
      ),
    },
    {
      field: "scoring_scheme_id",
      headerName: "Score Scheme",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Select
          style={{ width: "100%" }}
          value={cellValues.row.scoring_scheme_id || ""}
          onChange={(e) =>
            handleFieldChange(cellValues.row.id, "scoring_scheme_id", e.target.value)
          }
          displayEmpty
          variant="outlined"
        >
          <MenuItem disabled value="">
            Select Scheme
          </MenuItem>
          {schemes.map((s, index) => (
            <MenuItem key={index} value={s.id}>{s.scheme_name}</MenuItem>
          ))}
        </Select>
      ),
    },

    {
      field: "subject_id",
      headerName: "Subject",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Select
          labelId="category-label"
          id="subject"
          required
          value={cellValues.row.subject_id || ""}
          onChange={(e) =>
            handleFieldChange(cellValues.row.id, "subject_id", e.target.value)
          }
          displayEmpty
          className={classes.selectEmpty}
          // MenuProps={menuProps}
          variant="outlined"
          style={{ width: '100%' }}
        >
          <MenuItem disabled value="">
            <em className={classes.defaultselect}>Select subject</em>
          </MenuItem>
          {subjects &&
            subjects.map((s) => (
              <MenuItem key={s.id} value={s.subject_id}>
                {s.subject_name}
              </MenuItem>
            ))}
        </Select>
      ),
    },
  ];

  const rows = questions.map((d, index) => ({
    // id: d.id || "N/A",
    // exam_id: d.exam_id || "N/A",
    // question_number: d.q_prifix || "N/A",
    // question_type: d.question_type || "N/A",
    id: d.id || "N/A",
    question_number: d.question_number || "N/A",
    answer: d.answer || "",
    question_type: d.question_type || "N/A",
    scoring_scheme_id: d.scoring_scheme_id || "N/A",
    subject_id: d.subject_id || "N/A",
  }));

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.bgwhite} ${classes.inputpadding} ${classes.inputborder}`}
      >
        <QuestionListHead
          questionList={questionList}
          fetchData={fetchAnswerKey}
          examName={examName}
        />

        <TableView columns={columns} rows={rows} Heading={style} />

        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "10px",
            gap: "10px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate("/admin/exam")}
            className={classes.mr2}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            className={`${classes.custombtnblue}`}
          >
            {"Save Changes"}
          </Button>
        </Box>
      </div>
    </>
  );
}

export default AddMarks;
